// extracted by mini-css-extract-plugin
export var animationContainer = "_ml-0";
export var footer = "_ml-1";
export var gray = "_ml-2";
export var lineItem = "_ml-3";
export var lineItemImage = "_ml-4";
export var lineItemInfo = "_ml-5";
export var lineItemText = "_ml-6";
export var lineItems = "_ml-7";
export var modalContent = "_ml-8";
export var options = "_ml-9";
export var orderName = "_ml-a";
export var refundAmount = "_ml-b";